import theme from '@/common/theme';
import styled from 'styled-components';
import { Row } from '../grid/grid-component';

const Stepper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const StepView = styled.div`
  width: 100%;
  display: block;
  position: relative;
  margin-bottom: 20px;
  padding: 16px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px;
  margin-bottom: 8px;
`;

const StyledStepNumber = styled.div`
  background-color: ${(props) =>
    props.active ? theme.COLOR_PRIMARY : 'transparent'};
  border: ${(props) => (props.active ? 'unset' : '1px solid #58595b')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

const StyledStepNumberDone = styled.div`
  background-color: ${(props) =>
    props.active ? theme.COLOR_PRIMARY : '#CCD0E3'};
  border: ${(props) => (props.active ? 'unset' : '1px solid #CCD0E3')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

const StepName = styled.div`
  display: flex;
  align-items: center;
  border: ${(props) => (props.disabled ? 'unset' : '1px solid #58595b')};
  border-radius: 50px;
  padding-left: 8px;
  padding-right: 8px;
`;

const StepNameDone = styled.div`
  display: flex;
  align-items: center;
  background-color: '#CCD0E3';
  border: ${(props) => (props.disabled ? 'unset' : '1px solid #CCD0E3')};
  border-radius: 50px;
  padding-left: 8px;
  padding-right: 8px;
`;

const StepDivider = styled.div`
  border-bottom: 2px solid #58595b;
  width: 24px;
  transform: rotate(0deg);
`;

const RowStyle = styled(Row)`
  width: 100% !important;
  background-color: #eaedf3 !important;
  margin-bottom: 0px !important;
  padding: 24px !important;
  justify-content: space-between !important;
  margin-right: auto !important;
  margin-left: auto !important;
`;

const styledStepper = {
  StepDivider,
  StepName,
  StyledStepNumber,
  StepView,
  Actions,
  Stepper,
  RowStyle,
  StyledStepNumberDone,
  StepNameDone,
};

export default styledStepper;
